import React from "react";
import { Menu } from "antd";
import { useLocation } from "react-router-dom";
import { useMenu } from "../../../hook/useMenu";
import { useSelector } from "react-redux";
import { isOwnerSelector } from "../../../store/role/role.selector";

const LayoutMenu = (props) => {
  // -------------------------- VAR --------------------------
  const { mode } = props;
  const { items, menu } = useMenu();
  const location = useLocation();
  const pathname = location.pathname || "/";
  const keys = Object.values(items)?.find((item) => item?.url === pathname)
    ?.hightlight || ["1"];
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Menu
      mode={mode || "horizontal"}
      defaultSelectedKeys={keys}
      selectedKeys={keys}
      items={menu}
    />
  );
};

export default LayoutMenu;
